/**
 * Created by ganlu on 20/04/2017.
 */
class UserLoginService {
   constructor(UserAPI, $interval) {
      "ngInject";

      this.user = {};

      this.loading = false;
      this.loaded = false;

      this.UserAPI = UserAPI;
      this.$interval = $interval
   }

   getUserOrPromise() {

      if (this.loaded)
         return this.user;

      return this.getUserPromise();
   }

   getUser() {
      var num = 0 ;
      return new Promise((resolve, reject) => {

         const id = this.$interval(() => {
            num++
            if (num == 6) {//3秒 请求超时
               resolve(this.user)
               this.$interval.cancel(id)
            }
            if (this.loaded) {
               resolve(this.user)
               this.$interval.cancel(id)
            }
         }, 1000)

      });
   }

   getUserPromise() {

      let self = this;

      return new Promise((resolve, reject) => {

         self.loading = true;

         self.UserAPI.one().get().then(
            (user) => {
               window.localStorage.setItem("loginUser", JSON.stringify(user))
               for (let k in user) {
                  if (user.hasOwnProperty(k)) {
                     if (typeof (user[k]) !== 'function') {
                        self.user[k] = user[k];
                     }
                  }
               }
               self.user.avatar = self.user.avatar + '?s=' + Math.random()
               self.loading = false;
               self.loaded = true;

               resolve(self.user);
            },
            (response) => {

               self.loading = false;
               self.loaded = true;

               reject(response);
            }
         );
      });
   }

   loadUser(callback) {

      if (this.loading) return;

      this.getUserPromise().then((user) => {
         if (typeof (callback) === 'function') {
            callback(user);
         }
      });
   }

   logout() {

      let self = this;

      return new Promise((resolve, reject) => {
         self.UserAPI.one().customPOST({}, "logout").then(
            () => {
               for (let k in self.user) {
                  if (self.user.hasOwnProperty(k)) {
                     delete self.user[k];
                  }
               }

               resolve();
            },
            (response) => {
               reject(response);
            }
         );
      });
   }

   isGuest() {
      return this.user&&!this.user.id;
   }
}

export default UserLoginService;



// WEBPACK FOOTER //
// ./src/app/services/user-login.service.js